import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';

export const NavbarC = () => {
    const [isNavCollapsed, setIsNavCollapsed] = useState(true);
    const handleLinkClick = () => {
        setIsNavCollapsed(true);
    };
    return (
        <Navbar bg="white" expand="lg" sticky="top">
            <Container fluid className="py-2 px-4 px-lg-5">
                <Navbar.Brand as={NavLink} to="/" className="text-custom-green fw-bold">
                <img 
                    src='/images/logo.png'  // Updated to use the public folder
                    alt="lurantech-Logo" 
                    className="d-inline-block align-text-top me-2"
                    style={{ width: '164px', height: '56px' }} 
                />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarNav"  onClick={() => setIsNavCollapsed(!isNavCollapsed)}  />
                <Navbar.Collapse id="navbarNav" className="justify-content-end" in={!isNavCollapsed}>
                    <Nav>
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/" className={({ isActive }) => isActive? "active fw-bold fs-6 px-3": "fw-bold fs-6 px-3"}>
                            Home
                        </Nav.Link>
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/service" className={({ isActive }) => isActive? "active fw-bold fs-6 px-3": "fw-bold fs-6 px-3"}>
                            Service
                        </Nav.Link>
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/about-us" className={({ isActive }) => isActive? "active fw-bold fs-6 px-3": "fw-bold fs-6 px-3"}>
                            About Us
                        </Nav.Link>
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/case-studies" className={({ isActive }) => isActive? "active fw-bold fs-6 px-3": "fw-bold fs-6 px-3"}>
                            Case Studies
                        </Nav.Link>
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/teams" className={({ isActive }) => isActive? "active fw-bold fs-6 px-3": "fw-bold fs-6 px-3"}>
                            People
                        </Nav.Link>
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/blogs" className={({ isActive }) => isActive? "active fw-bold fs-6 px-3": "fw-bold fs-6 px-3"}>
                            Blogs
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
                <Navbar.Collapse id="navbarNav" className="justify-content-end" in={!isNavCollapsed}>
                    <Nav>    
                        <Nav.Link as={NavLink} onClick={handleLinkClick} to="/contact-us" className="fw-bold fs-6 px-3 bg-btn-custom-purple ml-50">
                            Contact Us
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};
